import Icon from '../components/Icon.vue'

Icon.register({"parachute-box":{"width":512,"height":512,"paths":[{"d":"M511.9 175C502.8 99.4 433.5 42.6 353.6 16.3 390 55.7 416 116.9 416 192H444.1L327.5 321.5C325 320.9 322.7 320 320 320H272V192H384C384 76.8 315.1 0 256 0S128 76.8 128 192H240V320H192C189.3 320 187 320.9 184.5 321.5L67.9 192H96C96 116.9 122 55.7 158.4 16.3 78.5 42.7 9.2 99.5 0.1 175-1 184.1 6.9 192 16.1 192H24.8L161.5 343.9C160.8 346.5 159.9 349.1 159.9 352V480C159.9 497.7 174.2 512 191.9 512H319.9C337.6 512 351.9 497.7 351.9 480V352C351.9 349.1 351 346.6 350.3 343.9L487.1 192H495.8C505.1 192 513 184.2 511.9 175z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/parachute-box.js
// module id = PWW1
// module chunks = 0